var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 30,
    viewBox: "0 0 43 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M36.214 34.822H6.644a.8.8 0 0 1-.8-.8V1.292a.8.8 0 0 1 .8-.8h29.57a.8.8 0 0 1 .8.8v32.73a.8.8 0 0 1-.8.8zm-29.37-1h29.17V1.492H6.844v32.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M31.504 25.422h-20.11a3 3 0 0 1-3-3v-12a3 3 0 0 1 3-3h20.11a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3zm-20.11-17a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h20.11a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2h-20.11zM24.714 31.612h-6.75a1.41 1.41 0 1 1 0-2.81h6.75a1.41 1.41 0 1 1 0 2.81zm-6.75-1.81a.41.41 0 1 0 0 .81h6.75a.41.41 0 1 0 0-.81h-6.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.954 37.802a3.35 3.35 0 0 1-3.34-3.31v-.14a.5.5 0 1 1 1 0v.14a2.34 2.34 0 0 0 4.68 0v-.14a.5.5 0 0 1 .5-.5.51.51 0 0 1 .5.5v.14a3.35 3.35 0 0 1-3.34 3.31zM31.194 37.802a3.34 3.34 0 0 1-3.34-3.31v-.14a.5.5 0 0 1 .5-.5.51.51 0 0 1 .5.5v.14a2.34 2.34 0 0 0 4.68 0v-.14a.5.5 0 0 1 .5-.5.51.51 0 0 1 .5.5v.14a3.35 3.35 0 0 1-3.34 3.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M10.534 32.372a2.16 2.16 0 1 1 0-4.32 2.16 2.16 0 0 1 0 4.32zm0-3.32a1.16 1.16 0 1 0 0 2.32 1.16 1.16 0 0 0 0-2.32zM32.124 32.372a2.16 2.16 0 1 1 0-4.32 2.16 2.16 0 0 1 0 4.32zm0-3.32a1.16 1.16 0 1 0 0 2.32 1.16 1.16 0 0 0 0-2.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.124 12.382a.5.5 0 0 1-.5-.5v-1l-4.5-5.76a.52.52 0 0 1 .08-.71.51.51 0 0 1 .71.09l4.6 5.86a.51.51 0 0 1 .11.31v1.21a.5.5 0 0 1-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M42.244 17.732h-2.24a.5.5 0 0 1-.5-.5v-5.12a.5.5 0 0 1 .5-.5h2.24a.5.5 0 0 1 .5.5v5.12a.51.51 0 0 1-.5.5zm-1.74-1h1.24v-4.12h-1.24v4.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.744 12.702a.5.5 0 0 1-.5-.5v-1.21a.45.45 0 0 1 .1-.29l4.6-6.21a.504.504 0 0 1 .81.6l-4.51 6.07v1a.5.5 0 0 1-.5.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M2.854 18.052H.624a.5.5 0 0 1-.5-.5v-5.12a.5.5 0 0 1 .5-.5h2.23a.5.5 0 0 1 .5.5v5.12a.5.5 0 0 1-.5.5zm-1.73-1h1.23v-4.12h-1.23v4.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.354 4.662h-13.56a.5.5 0 1 1 0-1h13.56a.5.5 0 0 1 .5.5.51.51 0 0 1-.5.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.1cd217f902f8c8652e7b64470d7ed49c.svg";
export { ForwardRef as ReactComponent };